import { useMemo } from 'react';

import { useLocalStorage } from '~hooks/index';

interface Props extends React.PropsWithChildren {
  permissions: string[];
}

const RestrictedComponent = ({ permissions, children }: Props) => {
  const { userData, userPermissions } = useLocalStorage();

  const isVisible = useMemo(() => {
    if (userData && permissions.length > 0) {
      return permissions.every((permission) =>
        userPermissions.includes(permission)
      );
    } else if (userData) return true;
    else return false;
  }, [userData, permissions]);

  return <>{isVisible && children}</>;
};

export default RestrictedComponent;
